import React from "react";
import { Badge } from "../../../../components/ui";
import { getNotifications, NotificationsRead } from "../../../../api";
import { Link } from "react-router-dom";
import { formatToLocalDateWithoutTimestamp, formatToLocalDate } from "utils";
import publisherStore from "../../../../flux/publisherStore";
import { getPublishers } from "../../../../flux/publisherAction";

const dateFormatting = (date) => {
  let formattedDate;

  try {
    formattedDate = formatToLocalDateWithoutTimestamp(date);
  } catch (e) {
    formattedDate = formatToLocalDate(date);
  }

  return formattedDate;
};

export default class Notifications extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      disabled: false,
      notifications: [],
      publisherData: publisherStore.getPublishers(),
    };
    this.toggleNotifications = this.toggleNotifications.bind(this);
    this.wrapperRef = React.createRef();
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
  }

  handleOutsideClick(e) {
    if (
      this.wrapperRef.current &&
      !this.wrapperRef.current.contains(e.target)
    ) {
      this.setState({ visible: false });
    }
  }

  getPublisherSmallAvatar = (id) => {
    if (!id || !this.state.publisherData) {
      return null;
    }
    const postPublisher = this.state.publisherData.find(
      (_publisher) => _publisher.id === id,
    );

    if (postPublisher) {
      return (
        postPublisher && postPublisher.avatar && postPublisher.avatar.small
      );
    }
  };

  refreshNotifications = async () => {
    const data = await getNotifications();
    this.setState({
      notifications: data.data,
    });
  };
  toggleNotifications = async () => {
    this.setState({
      visible: !this.state.visible,
    });
    const makeRead = await NotificationsRead();
    this.refreshNotifications();
  };

  onChange = () => {
    this.setState({ publisherData: publisherStore.getPublishers() });
  };

  componentDidMount = async () => {
    document.addEventListener("mousedown", this.handleOutsideClick);
    if (localStorage.getItem("user") !== null) {
      let user = JSON.parse(localStorage.getItem("user"));
      const resp = await getNotifications(user.id);
      if (resp !== undefined) {
        this.setState({
          notifications: resp.data,
        });
        setInterval(async () => {
          const resp = await getNotifications(user.id);
          if (resp && resp.data && resp.data) {
            this.setState({
              notifications: resp.data,
            });
            resp.data.map((a) => {
              if (
                Notification.permission === "granted" &&
                a.consumed === false
              ) {
                new Notification("New alert on Bitcoin.live!", {
                  body: `New alert by ${a.author.name}!`,
                });
              } else {
              }
            });
          }
        }, 60000);
      }
    } else {
      this.setState({
        disabled: true,
      });
    }
    publisherStore.addChangeListener(this.onChange);
    if (publisherStore.getPublishers().length === 0) getPublishers();
    return () => publisherStore.removeChangeListener(this.onChange);
  };

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleOutsideClick);
    publisherStore.removeChangeListener(this.onChange);
  }

  resolveType = (type) => {
    if (type === 1) {
      return "Alert";
    } else if (type === 2) {
      return "Alert Update";
    } else if (type === 3) {
      return "Post";
    } else if (type === 4) {
      return "Comment Reply";
    }
  };

  resolveLink = (post) => {
    if (post.type === 1) {
      return "/alerts/" + post.alertId;
    } else if (post.type === 2) {
      return "/alerts/" + post.alertId;
    } else if (post.type === 3) {
      return post.url;
    } else if (post.type === 4) {
      return post.post.url;
    }
  };

  resolveNotificationCount = () => {
    let count = 0;
    this.state.notifications &&
      this.state.notifications.length > 0 &&
      this.state.notifications.map((data) => {
        if (data.consumed === false) {
          count++;
        }
      });
    return count;
  };

  render() {
    return (
      <li
        ref={this.wrapperRef}
        style={{
          listStyle: "none",
          borderRight: "1px solid #ebebeb",
          display: "flex",
          height: window.screen.width > 767 ? "75px" : {},
        }}
        className="nav-item dropdown notifications"
      >
        <a
          className="nav-link nav-link-icon text-center"
          onClick={this.toggleNotifications}
          style={{
            cursor: "pointer",
            marginTop: window.screen.width > 767 ? 5 : {},
          }}
        >
          <div className="nav-link-icon__wrapper">
            <i className="material-icons">&#xE7F4;</i>
            {this.state.notifications &&
              this.state.notifications.length > 0 &&
              this.resolveNotificationCount() > 0 && (
                <Badge pill theme="danger">
                  {this.resolveNotificationCount()}
                </Badge>
              )}
          </div>
        </a>
        {!this.state.disabled && (
          <div
            className={`dropdown-menu dropdown-menu-small${this.state.visible ? " show" : ""}`}
            style={{ left: window.screen.width > 767 ? "-337px" : {} }}
          >
            {this.state.notifications &&
              this.state.notifications.length > 0 &&
              this.state.notifications.map((post, idx) => {
                const publisher =
                  post && (post.author || post.publisherOrStaff);

                return (
                  <Link
                    key={idx}
                    to={this.resolveLink(post)}
                    onClick={(e) => {
                      e.preventDefault();
                      const link = this.resolveLink(post);
                      window.location.href = link;
                    }}
                  >
                    <button type="button" className="dropdown-item">
                      <div
                        className="notification__icon-wrapper"
                        style={{ alignSelf: "center" }}
                      >
                        {this.getPublisherSmallAvatar(
                          publisher && publisher.id,
                        ) ? (
                          <div
                            className="card-post__author-avatar card-post__author-avatar--small"
                            style={{
                              backgroundImage: `url('${this.getPublisherSmallAvatar(
                                publisher.id,
                              )}')`,
                            }}
                          ></div>
                        ) : (
                          <div className="notification__icon">
                            <i className="material-icons">&#xe02f;</i>
                          </div>
                        )}
                      </div>
                      <div className="notification__content">
                        <span className="notification__category">
                          {this.resolveType(post.type)}
                        </span>
                        <p>
                          New {this.resolveType(post.type)}
                          {publisher && publisher.name ? (
                            <>
                              &nbsp;
                              {"by "}
                              <span className="text-success text-semibold">
                                {publisher && publisher.name}
                              </span>
                            </>
                          ) : null}
                          &nbsp;
                          <span>
                            {post && (post.publishedAt || post.createdAt)
                              ? "on " +
                                dateFormatting(
                                  post.publishedAt || post.createdAt,
                                )
                              : null}
                          </span>
                        </p>
                      </div>
                    </button>
                  </Link>
                );
              })}
            {this.state.notifications &&
              this.state.notifications.length === 0 && (
                <div className="dropdown-item">
                  <div className="notification__icon-wrapper">
                    No new notifications.
                  </div>
                </div>
              )}
          </div>
        )}
      </li>
    );
  }
}
